import { render, staticRenderFns } from "./dialog-device-events.vue?vue&type=template&id=2173b74f&"
import script from "./dialog-device-events.vue?vue&type=script&lang=js&"
export * from "./dialog-device-events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports